import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { DpsDeletedVmService } from './deleted-vms.service';
import { VcaAlertsService } from '../../../../../common/vca-alerts/vca-alerts.service';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { ResizeEvent } from 'angular-resizable-element';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../../refresh-shared-service';

@Component({
    selector: 'dps-deleted-vm-vc',
    styles: [require('./deleted-vms.scss')],
    template: require('./deleted-vms.html')
})
export default class DPSDeletedVmVc {
    private dpsVcList: any;
    private deletedVms: Array<any> = [];
    private loaded: boolean = false;
    private sideNavNotSelected: boolean = true;
    private isRestorePointsModalVisible: boolean;
    private restorePointModalHeader: String;
    private restorePointsModalMode: String;
    private selectedDeletedVm: any = {};
    private selectedVcHost: string = '';
    private sideNavStyle: Object = {};
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private selectedVC: any;

    constructor(private translate: TranslateService,
                private service: DpsDeletedVmService,
                private alert: VcaAlertsService,
                private rss: RefreshSharedService) {
        translate.use(GlobalVariables.LOCALE);
        this.isRestorePointsModalVisible = false;
        this.rsService = rss;
        this.currentClassName = 'DPSDeletedVmVc';
    }

    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
            this.handleEmittedValues(item);
        });
        this.getVcData();
    }

    handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName && this.selectedVC) {
            this.changeTable(this.selectedVC);
        }
    }

    getVcData() {
        this.service.getDpsVcList()
        .subscribe(
            data => {
                this.dpsVcList = data;
            },
            error => {
                console.log(error);
        });
    }

    changeTable(vcenter: any) {
        this.selectedVC = vcenter;
        this.sideNavNotSelected = false;
        this.loaded = false;
        this.selectedVcHost = vcenter.name;
        let vcenterID = vcenter.entity_id;
        this.service.getDpsDeletedVmList().subscribe(
            (data: any) => {
                this.deletedVms = [];
                let deletedVmList = data;
                for (let i = 0; i < deletedVmList.length; i+= 1) {
                    let deletedVM = deletedVmList[i];
                    let deletedVmVCID = deletedVM.vcenter_instanceId;
                    if (vcenterID === deletedVmVCID) {
                        this.deletedVms.push(deletedVM);
                    }
                }
                this.loaded = true;
            },
            error => {
                this.alert.danger(['Failed to retrieve deleted VMs', error],
                    'deleted-vm-grid');
                this.loaded = true;
            }
        );
    }

    onRestorePointsClick = (deletedVm) => {
        this.restorePointModalHeader = this.translate.instant('vcDpsModule.restorePoints.popupHeader') + deletedVm.name;
        this.restorePointsModalMode = DataProtectionVariables.RESTORE_MODES['DELETED_VM'];
        this.selectedDeletedVm = deletedVm;
        this.isRestorePointsModalVisible = true;
    };

    onRestorePointsModalClose = (emittedData) => {
        this.isRestorePointsModalVisible = false;
    };

    onResizeEnd(event: ResizeEvent): void {
        this.sideNavStyle = {
            width: `${event.rectangle.width}px`
        };
  }

    ngOnDestroy() {
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/deleted-vms/deleted-vms.component.ts